import React from 'react';
import MainNavbar from '../pages/MainNavbar';
import SubNav from './SubNav';
import BreadcrumbNav from './BreadcrumbNav';

const Header = ({ logoSrc, subNavItems }) => {
  return (
    <header className="site-header">
      <MainNavbar logoSrc={logoSrc} />
      <SubNav items={subNavItems} />
      <BreadcrumbNav />
    </header>
  );
};

export default Header;
